var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles),attrs:{"id":_vm.title}},[(_vm.passenger)?_c('div',{staticClass:"passenger-info",class:{ 'second-row': _vm.row === 2 }},[_vm._v("\n    "+_vm._s(_vm.passenger)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }